

const isProduction = process.env.NODE_ENV === 'production'
const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'

// 生产环境由 Nginx 将同域 /api 转发到后端，开发环境仍连接本机 8080。
const VUE_APP_BASEURL = isProduction ? '/api' : 'http://127.0.0.1:8080'
const VUE_APP_WS_URL = isProduction
  ? `${protocol}//${window.location.host}/api/websocket`
  : 'ws://127.0.0.1:8080/websocket'
const VUE_API1_BASEURL = VUE_APP_BASEURL
const VUE_API2_BASEURL = VUE_APP_BASEURL



export { VUE_APP_WS_URL, VUE_APP_BASEURL,VUE_API1_BASEURL,VUE_API2_BASEURL };
